<div class="container">
    <h1>Assessment Sicurezza Cyber per PMI</h1>

    <form id="assessmentForm" #assessmentForm>
        <div *ngFor="let item of questions; let qIndex = index"
            class="question">
            <!-- <div *ngFor="let i of [].constructor(30); let qIndex = index" class="question"> -->
            <!-- {{qIndex + 1}}. Domanda {{qIndex + 1}}:  -->
            {{qIndex + 1}}. {{item}}:
            <input type="radio" [name]="'q' + (qIndex + 1)" value="yes"> Sì
            <input type="radio" [name]="'q' + (qIndex + 1)" value="no"> No
        </div>
        <button type="button" (click)="calculateScore()">Calcola il Livello di
            Sicurezza</button>
    </form>

    <div class="result">
        Punteggio: {{score}}<br>
        Livello di Sicurezza: <span class="level">{{level}}</span>
    </div>

    <div class="canvas-container">
        <canvas id="myGauge" width="400" height="200" #myGauge></canvas>
    </div>
</div>
